import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { KeyboardCapslock } from "@mui/icons-material";
import React from "react";
import { Tooltip } from "@mui/material";
import { compareVersions } from "./version-utils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconContainer: {
      display: "inline-block",
      width: "24px", // Фиксированная ширина как у других иконок
    },
    icon: {
      color: "green",
      opacity: 0, // Прозрачность 0 вместо visibility: hidden
    },
  })
);

export const CurrentFirmware = (props: {
  defType?: number;
  defVersion: string | number;
  currType?: number;
  currVersion: string | number;
}) => {
  const classes = useStyles();
  const { defType, defVersion, currType, currVersion } = props;

  // Проверка для старого формата (sensor=false)
  const isCurrentWithType = defType !== undefined 
    ? defType === currType && compareVersions(defVersion, currVersion) === 0
    : compareVersions(defVersion, currVersion) === 0;

  // Для отладки: вывести параметры в консоль
  console.log("CurrentFirmware:", { 
    defType, 
    currType, 
    defVersion, 
    currVersion, 
    isCurrent: isCurrentWithType 
  });

  if (!isCurrentWithType) return null;

  return (
    <div className={classes.iconContainer}>
      <Tooltip title="Версия соответствует требуемой">
        <KeyboardCapslock className={classes.icon} />
      </Tooltip>
    </div>
  );
};